import React from 'react';
import { useParams } from 'react-router-dom';

import Breadcrumb from 'components/App/AppShell/components/Breadcrumb';
import useMapReveal from 'screens/Property/hooks/useMapReveal';
import LoadingSpinner from 'components/LoadingSpinner';
import MapLoadingPlaceholder from 'screens/Property/components/MapLoadingPlaceholder';
import PropertyMapWrapper from '../PropertyLandingMap/PropertyMapWrapper';
import CropZoneCard from './CropZoneCard';
import useCropZoneFeatures from './hooks/useCropZoneFeatures';

const CropZoneCreate = () => {
  const { fieldId, action, cropzoneId } = useParams();
  const breadcrumbTitle = action === 'edit' ? 'Edit' : 'New';
  const {
    field,
    selectedFeatures,
    setIsSaving,
    cropzone,
    isLoading,
    isFieldResolved,
    isSaving,
    mapCoordinates,
    zoom,
    setZoom,
    selectedFeatureIds,
    initialFeatures,
    handleSelectedFeatures,
    handleFeaturesChange
  } = useCropZoneFeatures(fieldId, cropzoneId);
  const isMapShown = !isLoading && !isSaving && !!mapCoordinates;
  // Only once the map is on screen: the features are derived after loading
  // ends, and an empty collection in between is not nothing to fit.
  const { revealMap, mapRevealClassName, showPlaceholder } = useMapReveal(
    isMapShown && !initialFeatures?.features?.length,
    !isMapShown
  );

  return (
    <>
      <Breadcrumb disabled>
        <Breadcrumb.Item
          title="Properties"
          value={`${breadcrumbTitle} Crop Zone`}
          isLast
        />
      </Breadcrumb>
      <div
        className="bg-white flex h-full w-full"
        data-testid="crop-zone-screen"
      >
        {/* min-w-0: a long option in a kit select (nowrap) would otherwise
            widen the panel and squeeze the map. */}
        <div className="flex flex-col w-1/3 min-w-0 h-auto m-4">
          {isLoading || !isFieldResolved ? (
            <div className="flex items-center justify-center h-full">
              <LoadingSpinner message="" size={50} label="Loading crop zone" />
            </div>
          ) : (
            <CropZoneCard
              field={field}
              features={selectedFeatures}
              isSaving={setIsSaving}
              cropzone={action === 'edit' ? cropzone : {}}
            />
          )}
        </div>
        <div className="relative w-full" id="map-wrapper-container">
          <MapLoadingPlaceholder show={!isMapShown || showPlaceholder} />
          {isMapShown && (
            <div
              data-testid="crop-zone-map"
              className={`h-full ${mapRevealClassName}`}
            >
              <PropertyMapWrapper
                onFit={revealMap}
                zoom={zoom}
                setZoom={setZoom}
                currentCoordinates={mapCoordinates}
                shapeIdSelected={selectedFeatureIds}
                geoJSONCollection={initialFeatures}
                onSelectFeatures={handleSelectedFeatures}
                onFeaturesChange={handleFeaturesChange}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CropZoneCreate;
